// extracted by mini-css-extract-plugin
export var growableInput = "_8f-0";
export var tagContainer = "_8f-2";
export var textInput = "_8f-1";